module.exports = __webpack_public_path__ + "static/media/5.c349a575.png";